import { selectResponse, madeFirstAttempt, clearResponses } from '../../mazeActions';
import { playAvatarAudio, setAvatarInstructions } from '../../../common/avatar/avatarActions';
import { unblockScreen, activateNextButton, blockScreen } from '../../../common/screen/screenActions';
import selectors from '../../../rootSelectors';
import { PRACTICE } from '../../../constants/assessmentItemType';

const getQuestionResponseIdx = (items, idx) => items[0].possibleResponses[idx].id;

const getQuestionId = (items) => items[0].id;

const playAudioAndSelectOptions = (questionItems, practiceInstructions) => (dispatch) => Promise.resolve()
    .then(() => {
        dispatch(selectResponse(getQuestionId(questionItems),
            getQuestionResponseIdx(questionItems, 0)));
        return dispatch(playAvatarAudio(practiceInstructions.practiceOptionOne));
    })
    .then(() => {
        dispatch(selectResponse(getQuestionId(questionItems),
            getQuestionResponseIdx(questionItems, 1)));
        return dispatch(playAvatarAudio(practiceInstructions.practiceOptionTwo));
    })
    .then(() => {
        dispatch(selectResponse(getQuestionId(questionItems),
            getQuestionResponseIdx(questionItems, 2)));
        return dispatch(playAvatarAudio(practiceInstructions.practiceOptionThree));
    });

export const playPracticeScript = (practiceInstructions) => (dispatch, getStore) => {
    const state = getStore();
    return Promise.resolve()
        .then(() => dispatch(playAvatarAudio(practiceInstructions.practiceIntro)))
        .then(() => dispatch(
            playAudioAndSelectOptions(selectors.getMazeQuestionItems(state, PRACTICE), practiceInstructions),
        ))
        .then(() => {
            dispatch(clearResponses());
            return dispatch(playAvatarAudio(practiceInstructions.practiceEnd));
        })
        .then(() => dispatch(unblockScreen()));
};

const handleCorrectResponseSelected = (id, index, practiceInstructions) => (dispatch) => {
    dispatch(selectResponse(id, index));
    dispatch(blockScreen());
    return dispatch(playAvatarAudio(practiceInstructions.practiceCorrectAnswerSelected))
        .then(() => {
            dispatch(activateNextButton());
            dispatch(setAvatarInstructions(practiceInstructions.clickOk));
            return dispatch(playAvatarAudio(practiceInstructions.clickOk))
                .then(() => {
                    dispatch(unblockScreen());
                });
        });
};

const handleFirstIncorrectResponseSelected = (practiceInstructions) => (dispatch, getStore) => {
    dispatch(blockScreen());
    dispatch(madeFirstAttempt());
    const state = getStore();
    return dispatch(playAvatarAudio(practiceInstructions.practiceIncorrectAnswerSelected))
        .then(() => dispatch(
            playAudioAndSelectOptions(selectors.getMazeQuestionItems(state, PRACTICE), practiceInstructions),
        ))
        .then(() => {
            dispatch(clearResponses());
            dispatch(madeFirstAttempt());
            return dispatch(playAvatarAudio(practiceInstructions.practiceEnd));
        })
        .then(() => {
            dispatch(unblockScreen());
        });
};

const handleSecondIncorrectResponseSelected = (questionId, correctResponseIndex, practiceInstructions) => (dispatch) => {
    dispatch(blockScreen());
    dispatch(selectResponse(questionId, correctResponseIndex));
    return dispatch(playAvatarAudio(practiceInstructions.practiceIncorrectAnswerSelectedTwice))
        .then(() => {
            dispatch(activateNextButton());
            dispatch(setAvatarInstructions(practiceInstructions.clickOk));
            return dispatch(playAvatarAudio(practiceInstructions.clickOk))
                .then(() => {
                    dispatch(unblockScreen());
                });
        });
};

export const selectPracticeScreenResponse = (questionId, responseIndex, practiceInstructions) => (dispatch, getStore) => {
    const state = getStore();
    const isFirstAttemptMade = selectors.getIsMazeFirstAttemptMade(state);
    const correctResponseIndex = selectors.getMazeCorrectResponse(state, PRACTICE, questionId);
    if (correctResponseIndex !== responseIndex) {
        if (!isFirstAttemptMade) {
            return dispatch(handleFirstIncorrectResponseSelected(practiceInstructions));
        }
        return dispatch(handleSecondIncorrectResponseSelected(questionId,
            correctResponseIndex, practiceInstructions));
    }
    return dispatch(handleCorrectResponseSelected(questionId, responseIndex, practiceInstructions));
};
